import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "bootstrap/dist/css/bootstrap.min.css";
import App from './App';
import { AuthContextProvider } from './context/AuthContext';
import { QueryClientProvider, QueryClient, useQuery, useQueryClient } from '@tanstack/react-query'



ReactDOM.render(
  <React.StrictMode>
    <AuthContextProvider>
      <App />
    </AuthContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

